import { useState } from 'react';

import { DisplayComponent } from '@/components/DisplayComponent';
import { DisplayHeading } from '@/components/DisplayHeading';
import { Header } from '@/components/Header';
import { ProgressBar } from '@/components/ProgressBar';
import { EVehicleAssetType, selectVehicleAssetType } from '@/context/borrower';
import { useAppSelector } from '@/context/storeHooks';
import { BuildYearManual } from '@/UserInput/BuildYearManual';
import { Kilometers } from '@/UserInput/Kilometers';
import { MakeManual } from '@/UserInput/MakeManual';
import { ModelManual } from '@/UserInput/ModelManual';
import { VariantManual } from '@/UserInput/VariantManual';
import { userFacingAssetTitle } from '@/utils/userFacingAssetTitle';

import { ManualVehicleButtons } from './ManualVehicleButtons';
import { ManualVehicleSearchButtons } from './ManualVehicleSearchButtons';

export const testId = 'ManualVehicle';

export function ManualVehicle(): JSX.Element {
    // ***** CONSTANTS *****
    const baseId = 'screen-manualVehicle';
    const [showErrors, setShowErrors] = useState<boolean>(false);
    const assetTitle = userFacingAssetTitle();
    const isAssetTypeEquipment =
        useAppSelector(selectVehicleAssetType) ===
        EVehicleAssetType.PLANT_EQUIPMENT;
    return (
        <div data-testid={testId}>
            <DisplayComponent baseId={baseId}>
                <Header />
                <ProgressBar />

                <DisplayHeading
                    title={`Select ${assetTitle}`}
                    infoText={`Please enter the ${assetTitle} details below to get an accurate quote`}
                />
                {!isAssetTypeEquipment && (
                    <Kilometers baseId={baseId} showErrors={false} />
                )}
                <BuildYearManual baseId={baseId} showErrors={showErrors} />
                <MakeManual baseId={baseId} showErrors={false} />
                <ModelManual baseId={baseId} showErrors={false} />
                {!isAssetTypeEquipment && (
                    <>
                        <VariantManual baseId={baseId} showErrors={false} />
                        <ManualVehicleSearchButtons />
                    </>
                )}
                <ManualVehicleButtons
                    baseId={baseId}
                    setShowErrors={setShowErrors}
                />
            </DisplayComponent>
        </div>
    );
}
